import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Icon } from 'elements';
import { classnames, classname } from 'utils';

import './Search.css';

class Search extends Component {
  cl = classname('search');

  constructor(props) {
    super(props);

    this.state = {
      placeholder: 'Поиск по компании'
    };
  }

  componentDidMount() {
    if (process.browser && window.innerWidth < 768) {
      this.setState({
        placeholder: 'Поиск по ...'
      });
    }
  }

  static propTypes = {
    /** Доп. класс */
    className: PropTypes.string,
    /** Значение */
    value: PropTypes.string,
    /** Событие изменения значения */
    onChange: PropTypes.func
  };

  render() {
    const { className, value, onChange } = this.props;

    const classes = classnames(className, this.cl());

    return (
      <div className={classes}>
        <input
          className={this.cl('field')}
          type={'text'}
          placeholder={this.state.placeholder}
          value={value}
          onInput={event => onChange(event.target.value)}
        />
        <Icon className={this.cl('icon')} name={'search'} />
      </div>
    );
  }
}

export default Search;
